(function () {
  const OFFSET = 90;

  const scrollWithOffset = (hash) => {
    const $target = $(hash);
    if (!$target.length) return;

    const position = $target.offset().top - OFFSET;

    $("html, body").stop().animate(
      { scrollTop: position },
      300
    );
  };

  const collapsibleContent = () => {
    $(".collapsible-content").each(function () {
      const $section = $(this);

      $section
        .find(".collapsible-content-summary")
        .off("click")
        .on("click", function () {
          const $summary = $(this);
          const $content = $summary.siblings(".collapsible-content-item__content");

          if (!$summary.hasClass("active")) {
            $section.find(".collapsible-content-summary.active").removeClass("active");
            $section.find(".collapsible-content-item__content").stop().slideUp(300);

            $summary.addClass("active");
            $content.stop().slideDown(300);
          } else {
            $summary.removeClass("active");
            $content.stop().slideUp(300);
          }
        });
    });
  };

  // ▼ 初期化
  collapsibleContent();

  // ▼ ページ内リンククリック時
  $(document).on("click", 'a[href^="#"]', function (e) {
    const hash = this.getAttribute("href");
    if (!hash || hash === "#") return;

    if ($(hash).length) {
      e.preventDefault();
      history.pushState(null, "", hash);
      scrollWithOffset(hash);
    }
  });

  // ▼ 直アクセス（URLに # が付いている場合）
  $(window).on("load", function () {
    if (location.hash) {
      setTimeout(() => {
        scrollWithOffset(location.hash);
      }, 100);
    }
  });

  // ▼ Shopify セクション再読込
  document.addEventListener("shopify:section:load", function () {
    setTimeout(() => {
      collapsibleContent();
      if (location.hash) {
        scrollWithOffset(location.hash);
      }
    }, 100);
  });
})();
// FAQ search (collapsible-content-box)
(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const input = document.getElementById("faqSearchInput");
    if (!input) return;
    const boxes = document.querySelectorAll(".collapsible-content-box");
    function highlight(element, keyword) {
      const regex = new RegExp(`(${keyword})`, "gi");
      element.innerHTML = element.textContent.replace(regex, "<mark>$1</mark>");
    }
    function removeHighlight(element) {
      element.innerHTML = element.textContent;
    }
    input.addEventListener("input", () => {
      const keyword = input.value.trim();
      boxes.forEach(box => {
        const items = box.querySelectorAll(".collapsible-content-block");
        items.forEach(item => {
          const text = item.textContent.toLowerCase();
          const match = text.includes(keyword.toLowerCase());
          item.style.display = match || keyword === "" ? "" : "none";
          const contentArea = item.querySelector(".collapsible-content-item__description");
          const titleArea = item.querySelector(".collapsible-content-item__heading");
          // 一度リセット
          removeHighlight(contentArea);
          removeHighlight(titleArea);
          if (match && keyword !== "") {
            highlight(contentArea, keyword);
            highlight(titleArea, keyword);
            const content = item.querySelector(".collapsible-content-item__content");
            if (content) content.style.display = "block";
          }
        });
      });
    });
  });
})();